import Image1 from "../../images/image1.jpg";
import Image2 from "../../images/image2.jpg";
import {
  InfoContainer,
  InfoH1,
  InfoH3,
  InfoP1,
  InfoP2,
  InfoP3,
  InfoP4,
  InfoContent,
  InfoImg,
} from "./InfoSectionElementsEN";

const InfoSectionEN = ({ id }) => {
  return (
    <>
      <InfoContainer id={id}>
        <InfoH1>About Us</InfoH1>
        <InfoH3>
          Welcome to the website of „ETS” - the manufacturer of peaks and
          adjusters for caps .
        </InfoH3>
        <InfoContent imgStart={false}>
          <InfoP1>
            The ETS company was founded in 1983 and has been a wide producer of
            baseball cap’s peaks and plastic adjusters ever since. We have many
            partners.. We are cutting our peaks out of a special plastic foam
            band of our own production. Thanks to that we can offer the
            opportunity of choosing the thickness of the peak in the range of
            1,2 mm to 2,2 mm. It can be used to any kind of gimp. We produce the
            band in two colors: white and black. We can bend the peaks on the
            special request of customers. In order to provide even better
            service, we can create new peak’s form according to client’s design.
          </InfoP1>
          <InfoP2>
            <InfoImg src={Image1} type="image/jpg" />
          </InfoP2>
          <InfoP3>
            <InfoImg src={Image2} type="image/jpg" />
          </InfoP3>
          <InfoP4>
            In our offer you can also find a vast range of plastic adjusters.
            Extra color assortment available on a special request. In order to
            simplify the way of searching for the peaks we divided them into
            groups according to the kind of a cap/hat they can be used for. To
            download the image of the peak tap on image of chosen peak.
          </InfoP4>
        </InfoContent>
      </InfoContainer>
    </>
  );
};

export default InfoSectionEN;
